import styled from "styled-components";

interface TextProps {
  variant?: "error" | "success";
}


export const Text = styled.p<TextProps>`
  font-size: 13px;
  color: ${({ theme, variant }) =>
    variant === "error"
      ? theme.colors.danger
      : variant === "success"
      ? theme.colors.success
      : theme.colors.muted};
`;